import { showToast, showLoadingToast, closeToast } from 'vant'

// 定义通用的默认持续时间
const DEFAULT_DURATION = 1500

const getDuration = (duration) => {
  return duration || DEFAULT_DURATION
}

const showCustomToast = (type, data) => {
  showToast({
    type,
    message: data?.message || data,
    duration: getDuration(data?.duration),
  })
}

const toast = {
  success: (data) => showCustomToast('success', data),
  error: (data) => showCustomToast('fail', data),
  warning: (data) => showCustomToast('warning', data),
  info: (data) => showCustomToast('info', data),
  text: (data) => showCustomToast('text', data),
  loading: (data) =>
    showLoadingToast({
      message: data?.message || data || '请求中...',
      forbidClick: true,
      duration: 0,
    }),
  close: () => closeToast(),
  // 安装方法支持 Vue 插件机制
  install: (app) => {
    const callableToast = (data) => toast.text(data)
    Object.assign(callableToast, toast)

    app.config.globalProperties.$toast = callableToast
    if (typeof window !== 'undefined') {
      window.toast = callableToast
    }
  },
}

export default toast
